import React from 'react';
import { Helmet } from '@dr.pogodin/react-helmet';

const SITE_URL = 'https://gradetestpro.ca';
const DEFAULT_IMAGE = 'https://n-micro.ca/images/gradetestpro.png';
const SITE_NAME = 'Grade Test Pro';

type SeoProps = {
  title: string;
  description: string;
  canonicalPath?: string;
  image?: string;
  noindex?: boolean;
  type?: 'website' | 'article' | 'profile';
};

/**
 * Per-page SEO tags: title, description, canonical, Open Graph, Twitter, robots.
 * Usage: <Seo title="..." description="..." canonicalPath="/grade/5" />
 */
const Seo: React.FC<SeoProps> = ({
  title,
  description,
  canonicalPath = '/',
  image = DEFAULT_IMAGE,
  noindex = false,
  type = 'website',
}) => {
  const url = `${SITE_URL}${canonicalPath.startsWith('/') ? canonicalPath : `/${canonicalPath}`}`;
  const fullTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta
        name="robots"
        content={noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large'}
      />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_CA" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default Seo;
